import React from "react";
import classNames from "classnames";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import CheckBox from "../../../../../../components/form/Checkbox";
import CroField from "../../../generalForm/CroField";
import CroPriceField from "../../../generalForm/CroPriceField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove, notForPublic, isNotLogged } from "../../../../CroUtils";
import { Source } from "../../../../enum";
import { isObject } from "lodash";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { Field } from "redux-form";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

export default ({
  meta: { submitFailed },
  fields,
  disabled,
  noPublicLogged,
  onSourceCheck,
  point4,
  ongoing,
  outgoing,
  t,
  defaultCountry,
  isLogged,
  isPublic,
  isPublicStatement,
  auth,
  isVillage,
  isReleased,
  onICOChange,
  aresErrors,
  versionChangedClass,
  ...args
}) => {
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index, sources) => {
        const checkboxLabelStyle =
          submitFailed && !sources.get(index).sourceType
            ? { color: "red" }
            : { color: "black" };
        const village = isNotLogged(auth) && (!isVillage || isReleased);

        return (
          <div
            key={index}
            className={classNames("cro-array-item", { noUnderline: !village }, versionChangedClass ? versionChangedClass(item) : "")}
          >
            <ItemNumber index={index} />
            {!disabled && fields.length > 1 && (
                <CroRemoveButton onClick={() => removeItem(index)} />
            )}
            <div className="cro-array-item-content">
              <div className="statementForm__arrayGrid">
                {(village || isLogged) && (
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                    title="Druh příjmu"
                    name={`${item}.type`}
                    component={AutoComplete}
                    disabled={disabled}
                    url="/api/ciselniky/typ-prijmu"
                    validate={[V.required, V.isDictionary]}
                    helpEnum={H[`${t}INCOME_TYPE`].r}
                    menuStyle={{ maxHeight: 200 }}
                  />
                )}
                {(village || isLogged) && (
                  <CroPriceField
                    className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                    title="Výše příjmu"
                    name={`${item}.price`}
                    component={Input}
                    disabled={disabled}
                    validate={[V.required, V.isNumeric]}
                    helpEnum={H[`${t}INCOME_PRICE`].r}
                  />
                )}
                {isObject(sources.get(index).type) &&
                  sources.get(index).type.name.startsWith("jin") &&
                  isLogged &&
                  !isPublic &&
                  !point4 &&
                  !ongoing &&
                  !outgoing && (
                    <div className="statementForm__arrayFull">
                      <CroField
                        className={versionChangedClass ? versionChangedClass(`${item}.specification`) : ""}
                        title="Specifikace"
                        name={`${item}.specification`}
                        component={Input}
                        disabled={disabled}
                        validate={[V.required]}
                      />
                    </div>
                  )}
                {(village || isLogged) && (
                  <>
                    <div className="statementForm__arrayFull">
                      <div className="checkbox-row">
                        <Field
                          className={versionChangedClass ? versionChangedClass(`${item}.sourceType`) : ""}
                          name={`${item}.sourceType`}
                          component={Input}
                          type="hidden"
                          style={{ display: "none" }}
                          validate={[V.required]}
                        />
                        <div className="checkbox">
                          <label
                            className="title"
                            style={checkboxLabelStyle}
                          >
                            Zdroj - Fyzická osoba
                          </label>
                          <CheckBox
                            value={
                              sources.get(index).sourceType === Source.PERSON
                            }
                            onChange={onSourceCheck(
                              `${item}.sourceType`,
                              Source.PERSON,
                            )}
                            disabled={disabled}
                            aria-label="Zdroj - Fyzická osoba"
                          />
                        </div>
                        <div className="checkbox">
                          <label
                            className="title"
                            style={checkboxLabelStyle}
                          >
                            Zdroj - Právnická osoba
                          </label>
                          <CheckBox
                            value={
                              sources.get(index).sourceType ===
                              Source.LEGAL_PERSON
                            }
                            onChange={onSourceCheck(
                              `${item}.sourceType`,
                              Source.LEGAL_PERSON,
                            )}
                            disabled={disabled}
                            aria-label="Zdroj - Právnická osoba"
                          />
                        </div>
                        <div className="checkbox">
                          <label
                            className="title"
                            style={checkboxLabelStyle}
                          >
                            Zdroj - jiný
                          </label>
                          <CheckBox
                            value={
                              sources.get(index).sourceType === Source.OTHER
                            }
                            onChange={onSourceCheck(
                              `${item}.sourceType`,
                              Source.OTHER,
                            )}
                            disabled={disabled}
                            aria-label="Zdroj - jiný"
                          />
                          <span className="help-icon">
                            <Help
                              helpEnum={H[`${t}INCOME_OTHER`].r}
                              disabled={disabled}
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    {sources.get(index).sourceType === Source.PERSON &&
                      (village || isLogged) && (
                        <div className="statementForm__arrayFull">
                          <div className="statementForm__arrayGrid statementForm__arrayGrid--3col">
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.firstName`) : ""}
                              title="Jméno"
                              name={`${item}.firstName`}
                              component={Input}
                              disabled={disabled}
                              validate={[
                                V.required,
                                V.textSpaceDashOnly,
                                V.noSpaceStartEnd,
                              ]}
                            />
                            {notForPublic(isPublicStatement, auth) && (
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.middleName`) : ""}
                                title="Další jména"
                                name={`${item}.middleName`}
                                component={Input}
                                disabled={disabled}
                              />
                            )}
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.lastName`) : ""}
                              title="Příjmení"
                              name={`${item}.lastName`}
                              component={Input}
                              disabled={disabled}
                              validate={[
                                V.required,
                                V.textSpaceDashOnly,
                                V.noSpaceStartEnd,
                              ]}
                            />
                          </div>
                        </div>
                      )}
                    {sources.get(index).sourceType === Source.LEGAL_PERSON &&
                      (village || isLogged) && (
                        <div className="statementForm__arrayFull">
                          <div className="statementForm__arrayGrid">
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.name`) : ""}
                              title="Obchodní firma/název"
                              name={`${item}.legalPerson.name`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                              helpEnum={H[`${t}INCOME_LEGAL_PERSON_NAME`].r}
                            />
                            <div>
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.identificationNumber`) : ""}
                                title="IČO"
                                name={`${item}.legalPerson.identificationNumber`}
                                component={IcoInput}
                                disabled={disabled}
                                validate={[V.required, V.isNumeric]}
                                helpEnum={H[`${t}INCOME_IDENTIFICATION_NUMBER`].r}
                                onICOChange={(val) => onICOChange && onICOChange(index, val)}
                              />
                              {aresErrors && aresErrors[index] && (
                                <span className="cro-ares-error">{aresErrors[index]}</span>
                              )}
                            </div>

                            <p className="statementForm__arrayLabel">
                              Sídlo právnické osoby{" "}
                              <Help
                                helpEnum={H[`${t}INCOME_ADDRESS`].r}
                                disabled={disabled}
                              />
                            </p>

                            <CroCountry
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.country`) : ""}
                              title="Stát"
                              name={`${item}.legalPerson.address`}
                              disabled={disabled}
                              form="statementForm"
                              validate={[V.required]}
                              defaultCountry={defaultCountry}
                            />
                            <CroMunicipality
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.municipality`) : ""}
                              title="Obec"
                              name={`${item}.legalPerson.address`}
                              disabled={disabled}
                              form="statementForm"
                              validate={[V.required]}
                            />

                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.zip`) : ""}
                              title="PSČ"
                              name={`${item}.legalPerson.address.zip`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                            />

                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.street`) : ""}
                              title="Ulice"
                              name={`${item}.legalPerson.address.street`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                            />
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.orientationNumber`) : ""}
                              title="Č.p./Č.o."
                              name={`${item}.legalPerson.address.orientationNumber`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                              helpEnum={H.HOUSE_NUMBER.r}
                            />
                          </div>
                        </div>
                      )}
                    {isLogged && !isPublic && (
                      <div className="statementForm__arrayFull">
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                          title="Poznámka"
                          name={`${item}.note`}
                          component={Input}
                          fullWidth
                          disabled={disabled}
                          helpEnum={H[`${t}INCOME_NOTE`].r}
                          maxlen={1000}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_INCOMES.r} />
        </div>
      )}
    </div>
  );
};
